// 버츄펫 메타 정보 인터페이스 (pet_profile 의 메타 컬럼과 1:1 매핑)
// 이 모듈이 "계약"이다 — 컴포넌트/부모/저장 로직 모두 여기 정의를 따른다.

/**
 * @typedef {Object} VirtupetMeta
 * @property {string}      name    - 펫 이름 (필수, 비어있지 않은 문자열)
 * @property {number|null} age     - 나이 (필수, 양의 정수)
 * @property {string}      mbti    - MBTI (필수, MBTIS 중 하나)
 * @property {string}      gender  - 성별 (필수, GENDERS 중 하나)
 * @property {string}      job     - 직업 (필수, JOBS 중 하나)
 * @property {string}      planet  - 행성 (필수, PLANETS 중 하나)
 */

export const MBTIS = [
  "ISTJ", "ISFJ", "INFJ", "INTJ",
  "ISTP", "ISFP", "INFP", "INTP",
  "ESTP", "ESFP", "ENFP", "ENTP",
  "ESTJ", "ESFJ", "ENFJ", "ENTJ",
];

export const GENDERS = ["남성", "여성", "중성"];

export const JOBS = [
  "농부", "목수", "광부", "사냥꾼", "요리사", "의사",
  "교사", "연구원", "기술자", "예술가", "연예인", "운동선수",
];

export const PLANETS = [
  "수성 (Mercury)", "금성 (Venus)", "지구 (Earth)", "화성 (Mars)",
  "목성 (Jupiter)", "토성 (Saturn)", "천왕성 (Uranus)", "해왕성 (Neptune)",
];

export const META_KEYS = ["name", "age", "mbti", "gender", "job", "planet"];

/** 리스트에서 랜덤 항목 선택 */
export const pickRandom = (list) => list[Math.floor(Math.random() * list.length)];

/** 빈 메타 생성 (초기/주입 기본값) @returns {VirtupetMeta} */
//  age는 0 고정(갓 태어난 펫) — 입력 UI에서 비활성, 값은 항상 0.
export const createEmptyMeta = () => ({
  name: "",
  age: 0,
  mbti: "",
  gender: "",
  job: "",
  planet: "",
});

/** 객체가 VirtupetMeta 형태인지 (모든 키 존재) — prop validator 용 */
export const isMetaShape = (m) => !!m && typeof m === "object" && META_KEYS.every((k) => k in m);

/** 모든 필드가 유효하게 채워졌는지 (전부 필수) @param {VirtupetMeta} m */
export const isMetaComplete = (m) => {
  if (!isMetaShape(m)) return false;
  const nameOk = typeof m.name === "string" && m.name.trim().length > 0;
  const ageOk = Number.isInteger(m.age) && m.age >= 0; // age 0 고정 허용
  const inList = (v, list) => typeof v === "string" && list.includes(v);
  return (
    nameOk &&
    ageOk &&
    inList(m.mbti, MBTIS) &&
    inList(m.gender, GENDERS) &&
    inList(m.job, JOBS) &&
    inList(m.planet, PLANETS)
  );
};
